//@ts-nocheck
import {
  Box,
  ButtonNew,
  ColorOptions,
  IconNew,
  Image,
  ModBox,
  Spacer,
  Text as NewText,
  Text,
  TextNew,
} from '@jfs/ui-new'
import { useNavigation } from '@react-navigation/native'
import { FC, useRef, useState } from 'react'
import { Animated, ScrollView } from 'react-native'
import ContactUs from '../../comps/ContactUs'
import { Modal, ModalTypes } from '../../comps/ModalWeb'
import Navbar from '../../comps/Nav'
import NavMob from '../../comps/NavMobile'
import { colors } from '../../util/colors'
import useFontSize from '../../util/useFontSize'
import usePadding from '../../util/usePadding'
import { isMobileWidth, isTabletWidth, useWindowDimensions } from '../../util/util'
import { AdvantageSection } from './AdvantageSection'
import { AllCardsLayout } from './AllCardsLayout'
import { sectionData } from './data'
import { Faqs } from './Faqs'
import { HorizontalLayout } from './HorizontalLayout'
import { ManageVoiceBox } from './ManageVoiceBox'
import { MultiLanguage } from './MultiLanguage'
import { Statistics } from './Statistics'
import { styles } from './styles'
interface ProductsProps {
  id: any
}

const PgProduct: FC<ProductsProps> = ({ id }: ProductsProps) => {
  const { headerSize, textSize, headerLineHeight } = useFontSize()

  const [navVisible, setNavVisible] = useState(false)
  const handleNav = (): void => {
    document.body.style.overflow = 'hidden' // body scroll disabled
    setNavVisible((prev) => !prev)
  }

  const setVisiblity = (): void => {
    document.body.style.overflow = 'scroll' // body scroll disabled
    setNavVisible(false)
  }
  const viewPortWidth = useWindowDimensions()

  const isMobile = viewPortWidth < 600
  const isTab = isTabletWidth(viewPortWidth)
  const nav = (
    <Box>
      <NavMob onPress={setVisiblity} />
    </Box>
  )
  const resPadding = usePadding()
  const themedStyle = styles(viewPortWidth, resPadding)
  const dots = require('../../assets/svg/dots.svg')

  const screenWidth = useWindowDimensions()
  const [gridTopOffset, setGridOffset] = useState(0)
  const [gridBottomOffset, setGridBottomOffSet] = useState(0)

  const animatedScrollingvalue = useRef(new Animated.Value(0)).current
  const animate = animatedScrollingvalue.interpolate({
    inputRange: [gridTopOffset, gridBottomOffset],
    outputRange: [gridTopOffset, gridBottomOffset - 100],
    extrapolate: 'clamp',
  })

  const onLayout = (evt: any) => {
    setGridOffset(evt.nativeEvent.layout.top - 24)
    setGridBottomOffSet(evt.nativeEvent.layout.top + evt.nativeEvent.layout.height / 3)
  }

  const isMob = isMobileWidth(screenWidth)
  const navigation = useNavigation()
  return (
    <>
      <Modal view={nav} visible={navVisible} onPress={setVisiblity} type={ModalTypes.NAVBAR_RIGHT} />
      <Navbar isBg={true} onPress={handleNav} hamBurgerType="primary" showSignin={true} />

      <Box {...themedStyle.outerontainer} h={'calc(100vh - 72px)'}>
        <ScrollView
          onScroll={
            !isMobile &&
            Animated.event([{ nativeEvent: { contentOffset: { y: animatedScrollingvalue } } }], {
              useNativeDriver: true,
            })
          }
          scrollEventThrottle={16}>
          <Animated.View
            style={[
              {
                paddingRight: 0.8 * resPadding,
                width: 0.5 * screenWidth,
                position: 'absolute',
                top: 200,
                zIndex: 1000,
                paddingLeft: resPadding,
                display: isMob ? 'none' : 'flex',
                opacity: animatedScrollingvalue,
              },
              { transform: [{ translateY: animate }] },
            ]}>
            <Text fontFamily={'jiotype-black'} fontSize={headerSize} lineHeight={isMobile ? 36 : 72}>
              {sectionData[id].checkListheader}
            </Text>
          </Animated.View>
          <Box
            {...themedStyle.container}
            pr={sectionData[id]?.isFullWidth ? 0 : resPadding}
            bg={colors.JIO_PRIMARY_ALPHA as ColorOptions}
            pt={isTab ? 60 : isMobile ? 30 : 72}>
            <Box {...themedStyle.textContainer} f={isMob ? undefined : sectionData[id]?.isFullWidth ? 0.7 : 0.5}>
              <Box alignItems="center" flexDirection={'row'}>
                {!!sectionData[id]?.lpImage && (
                  <Image
                    resizeMode="contain"
                    source={sectionData[id]?.lpImage}
                    width={isTab ? 120 : isMobile ? (id === 'vault' ? 24 : 32) : id === 'paycollect' ? 54 : 40}
                    height={isTab ? 123 : isMobile ? (id === 'vault' ? 24 : 32) : id === 'paycollect' ? 54 : 40}
                  />
                )}
                {!!sectionData[id]?.headerIcon && (
                  <IconNew
                    color={'WHITE'}
                    id={sectionData[id]?.headerIcon}
                    size={id === 'console' || id === 'oneqr' ? 24 : 32}
                  />
                )}
                <Spacer size={isMobile || isTab ? 8 : 'MEDIUM'} direction="horizontal" />
                <NewText
                  fontSize={textSize}
                  color="WHITE"
                  letterSpacing={4.2}
                  fontFamily={'jiotype-medium'}
                  opacity={isTab ? 0.6 : 0.9}>
                  {sectionData[id]?.id?.toUpperCase()}
                </NewText>
                <Spacer size={isMobile || isTab ? 8 : 'MEDIUM'} direction="horizontal" />
                <Box
                  borderBottomWidth={1}
                  width={isMobile || isTab ? 40 : 72}
                  borderColor="WHITE"
                  opacity={0.9}
                  left={-2}
                />
              </Box>
              <Spacer size={isTab ? 56 : 18} />
              <NewText fontFamily="jiotype-black" fontSize={headerSize} color={'WHITE'} lineHeight={isMob ? 36 : 66}>
                {sectionData[id]?.header}
              </NewText>
              {id !== 'voicebox' && <Spacer size={isMob ? 16 : 24} />}
              <Box maxWidth={isMob ? '100%' : '85%'}>
                <NewText
                  fontFamily="jiotype-medium"
                  fontSize={isTab || isMobile ? 14 : 18}
                  lineHeight={isMob ? 24 : 30}
                  color="WHITE"
                  opacity={0.9}>
                  {sectionData[id]?.subHeader}
                </NewText>
                {id === 'voicebox' && <Spacer size={isMobile ? 24 : 40} direction={'vertical'} />}
                <ButtonNew
                  hide={id !== 'voicebox'}
                  title={'Contact Us'}
                  {...style.contactUsButton}
                  width={isMobile || isTab ? 144 : 198}
                  height={isMobile || isTab ? 48 : 56}
                  children={
                    <TextNew
                      fontFamily="jiotype-bold"
                      color="WHITE"
                      fontSize={isMobile || isTab ? 14 : 12}
                      title={'Contact Us'}
                    />
                  }
                  onPress={() => navigation?.navigate('contact')}
                />
              </Box>
              <Spacer size={isMobile ? 80 : 'HUGE'} />
              {isMobile && <Box height={2} w={48} bg={colors.HIGHLIGHT as ColorOptions} alignSelf={'center'} />}
            </Box>
            <Spacer direction="horizontal" size={id === 'voicebox' ? 0: 24} />
            <Box
              flexGrow={sectionData[id]?.isFullWidth ? 1 : undefined}
              f={sectionData[id]?.isFullWidth || isMob ? undefined : 0.5}>
              <Image
                resizeMode={id === 'oneqr' ? 'contain' : 'contain'}
                height={isMobile ? 300 : 550}
                width={isMobile && sectionData[id]?.isFullWidth ? '115%' : '100%'}
                source={sectionData[id]?.headerImage}
              />
            </Box>
          </Box>
          <Statistics data={sectionData[id].stats} />
          <AdvantageSection data={sectionData[id]} />
          <Box h={isMob ? 32 : 120} w={'100%'} flexDirection={'row'} zIndex={-1} backgroundColor={'WHITE'}>
            {!isMobile && <Box f={0.5} bg={'#24397A0A' as ColorOptions} />}
            <Box f={isMobile ? 1 : 0.5} backgroundColor={'#24397A14' as ColorOptions} />
          </Box>
          <Box marginTop={isMob ? -32 : -120} onLayout={onLayout}>
            <AllCardsLayout data={sectionData[id]} />
          </Box>
          <MultiLanguage hide={id !== 'voicebox'} />
          <HorizontalLayout data={sectionData[id]?.contentMap2} />
          <ManageVoiceBox hide={id !== 'voicebox'} />
          <Faqs hide={id !== 'voicebox'} />
          <ModBox marginTop={isMobile ? 48 : -120} show={id !== 'voicebox'}>
            <ContactUs type={'footer'} />
          </ModBox>
        </ScrollView>
      </Box>
    </>
  )
}

const style = {
  contactUsButton: {
    type: 'primary',
    borderRadius: 8,
    color: colors.HIGHLIGHT as ColorOptions,
  } as ButtonProps,
}
export default PgProduct
